 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		4: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"3de7dd93d00b85dcafac825360a048cd723b6dd6","1":"6dd19605b93709e96b5321c6e266e8182aba2aa3","2":"f651e2d2bf0a8ec384cfcc8c222636db96c688e0","3":"ddf828b6bca7a99f02fed042d09ea0daaf297f59","6":"component---cache-caches-gatsby-plugin-offline-app-shell-js","7":"component---src-pages-404-tsx","8":"component---src-pages-agb-tsx","9":"component---src-pages-blog-fruehlingstrends-2020-flechtmuster-index-tsx","10":"component---src-pages-blog-fruehlingstrends-2020-hellblaue-taschen-index-tsx","11":"component---src-pages-blog-fruehlingstrends-2020-index-tsx","12":"component---src-pages-blog-fruehlingstrends-2020-xxl-hobos-index-tsx","13":"component---src-pages-blog-geschenkideen-valentinstag-frauen-tsx","14":"component---src-pages-blog-wintertrends-2019-2020-cremefarben-index-tsx","15":"component---src-pages-blog-wintertrends-2019-2020-gestreifte-maentel-index-tsx","16":"component---src-pages-blog-wintertrends-2019-2020-index-tsx","17":"component---src-pages-blog-wintertrends-2019-2020-kroko-optik-index-tsx","18":"component---src-pages-blog-wintertrends-2019-2020-leder-index-tsx","19":"component---src-pages-blog-wintertrends-2019-2020-leoparden-print-index-tsx","20":"component---src-pages-blog-wintertrends-2019-2020-patchwork-index-tsx","21":"component---src-pages-blog-wintertrends-2019-2020-schlangenleder-optik-index-tsx","22":"component---src-pages-blog-wintertrends-2019-2020-steppjacken-index-tsx","23":"component---src-pages-blog-wintertrends-2019-2020-trenchcoats-index-tsx","24":"component---src-pages-blog-wintertrends-2019-2020-warme-pullover-winter-index-tsx","25":"component---src-pages-datenschutz-tsx","26":"component---src-pages-impressum-tsx","27":"component---src-pages-index-tsx","28":"component---src-pages-marken-tsx","29":"component---src-templates-brand-page-tsx","30":"component---src-templates-brand-sale-page-tsx","31":"component---src-templates-category-brand-page-tsx","32":"component---src-templates-category-luxury-page-tsx","33":"component---src-templates-category-page-tsx","34":"component---src-templates-category-sale-page-tsx","35":"component---src-templates-luxury-page-tsx","36":"component---src-templates-product-page-tsx","37":"component---src-templates-sale-page-tsx"}[chunkId]||chunkId) + "-" + {"0":"401d6485347fa62a579a","1":"c43217ba619696a0f12f","2":"01ade6030a73cae64501","3":"ec5cc03b0e73c2b64984","6":"34f71df80a3e2854dd32","7":"063f21122fdfd51db10d","8":"dcf6ee445f687156ce66","9":"43a95ab3a99a6fbd1a94","10":"fb9db15621b4e56933c1","11":"14f50de51588f1f4bf22","12":"57de2dd7fa11e390dd69","13":"75ebf5c2350a8f76c3af","14":"dcc40cf98685159307b0","15":"866148a32ceaca8849a5","16":"6bd9e59bf0d58d6bcae1","17":"8cf212e1af0bb1761a23","18":"cf6d8593fa7f93d7515a","19":"d866d98dcae33acda200","20":"87ce085ac4e51a0a87dd","21":"47b9aa654f74571f2de6","22":"264fa73bfa0265541a9b","23":"922798fbfa24ac5dd552","24":"fff7ab6d5b3e7280ba7d","25":"679cf2c92a5211173a4b","26":"6a402d052063f78277e0","27":"e5bda25cc1f9d36674e9","28":"fa941a78a0fc922ef832","29":"7697f52374b2cd9a034e","30":"76dd069f4427032e3db5","31":"f6d9c144e200639fdce7","32":"6d5f4a1d3496e225c118","33":"b66b17c95f05a9fc3e9c","34":"e96322a48819aee3f4a8","35":"12eed56d200b5c3ea594","36":"3e554e3433b374260362","37":"be24b2f9c33b093b851f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
